export default __webpack_public_path__ + "static/media/Sheep Placenta 80000_[front on].43a7d995.png";